// Final Analytical Review Card V2 — the 316(a) tab in Completion (components/far/*), EN + AR. Merged into lib/i18n.js
// translations (big-file rule: new strings in their own file). No provider names; no standards paragraph numbers.
export const I18N_FAR = {
  en: {
    // Batch 33 · B33-1 (owner): "Completion" → "Completion forms"; the review is its own sidebar item
    layoutNav: {
      items: {
        completion: "Completion forms",
        final_analytical_review: "Final analytical review",
      },
    },
    far: {
      selectEngagement: "Select an engagement to open its final analytical review.",
      tabForms: "Forms",
      tabFar: "Final analytical review",
      title: "316(a) Final analytical review",
      intro: "Figures are computed from the statements. Remarks, the evaluation and sign-offs are kept on form {ref}.",
      loading: "Loading the final analytical review…",
      loadFailed: "The final analytical review could not be loaded.",
      refresh: "Refresh",
      refreshed: "Figures refreshed",
      computedAt: "Computed",
      exportPdf: "Export PDF",
      exportXlsx: "Export Excel",
      exportFailed: "The export could not be created.",
      locked: "This engagement is locked — the review is read-only.",
      changedAfterSignoff: "The figures changed after this review was signed off. Review the changes and sign off again.",
      layer: {
        cyAdj: "Including audit adjustments",
        cyUnadj: "Unadjusted figures from client data",
        py: "Prior year",
      },
      priorNote: "Prior year from the prior-year ledger — may differ from the audited comparatives if prior-year adjustments were not booked.",
      thresholds: "Highlight rule: movement more than performance materiality ({pm}) and more than {pct}% of the prior year (both). For information only — nothing is blocked.",
      noThresholds: "No highlight: materiality is not set.",
      overrideBtn: "Change the expected amount",
      overrideExpected: "Expected amount",
      overrideReason: "Reason (required)",
      overrideSave: "Save",
      overrideCancel: "Cancel",
      overrideUndo: "Undo the change",
      overridden: "Changed by the auditor ({by}): {reason} — computed {computed}",
      overrideSaved: "Expectation changed.",
      overrideRemoved: "The computed expectation is back.",
      overrideFailed: "The expectation could not be changed.",
      overridePending: "Changed (not saved yet): {reason} — computed {computed}",
      savedAt: "Saved in the form",
      workDonePlaceholder: "Work done on this line (optional)",
      nothingToSave: "Nothing changed — nothing to save.",
      saveFailed: "The final analytical review could not be saved.",
      figuresNotSaved: "The figures shown are not saved in the form yet — press Save to record them.",
      figuresChangedUnsaved: "The figures changed since they were last saved in the form — press Save to record the new figures.",
      sec: {
        lines: "Financial statement lines",
        ratios: "Ratios",
        planning: "Planning vs completion",
        expectations: "Expectations built from engagement data",
        relationships: "Balance-sheet relationships",
        monthly: "Monthly trends",
        conclusion: "Conclusion",
      },
      col: {
        line: "Line",
        movement: "Movement",
        movementPct: "Movement %",
        ajeEffect: "Effect of adjustments",
        remark: "Remark / explanation",
        links: "Work done",
        ratio: "Ratio",
        change: "Change",
        planning205a: "At planning (205(a))",
        expectation: "Expectation",
        formula: "How it is built",
        expected: "Expected",
        actual: "Actual",
        difference: "Difference",
        relationship: "Relationship",
        ratioValue: "From the statements",
        dataValue: "From the data",
        month: "Month",
        revenue: "Revenue",
        costOfSales: "Cost of sales",
        grossMargin: "Gross margin %",
        payroll: "Payroll",
        otherCosts: "Other operating costs",
      },
      highlight: "Large movement — for information",
      crossed: "Crossed a threshold since planning",
      subtotal: "Subtotal",
      sfp: "Statement of financial position",
      pl: "Profit or loss",
      saveRemark: "Save",
      remarkSaved: "Remark saved",
      remarkFailed: "The remark could not be saved.",
      remarkPlaceholder: "Explain the movement (optional)",
      aiDraftMarker: "AI draft — confirm",
      confirm: "Confirm",
      confirmed: "Draft confirmed",
      draftOne: "Draft explanation",
      draftHighlighted: "Draft for highlighted lines",
      drafted: "Draft added — edit or confirm it",
      noAiKey: "No AI key is set up for your firm — explanations can be typed.",
      noHighlighted: "No highlighted lines to draft for.",
      links: { misstatements: "Misstatements", risks: "Risks", kams: "Key audit matters", none: "None recorded" },
      planningAje: "Effect of the posted adjusting entries, line by line",
      planningNoAje: "No posted adjusting entry changes a line.",
      planningRatios: "Ratios that crossed a threshold since planning",
      planningNoRatios: "No ratio crossed a threshold.",
      planning205a: "What 205(a) recorded at planning (read-only)",
      planning205aEmpty: "205(a) was not filled at planning.",
      noData: "No data to build an expectation",
      addExpectation: "Add an expectation",
      expLabel: "Expectation",
      expExpected: "Expected amount",
      expLine: "Compare to line",
      expFormula: "How it is built",
      add: "Add",
      remove: "Remove",
      expAdded: "Expectation added",
      expRemoved: "Expectation removed",
      expFailed: "The expectation could not be saved.",
      custom: "Added by the auditor",
      monthlyNeedsRun: "Monthly trends are computed in the background. Press Run to compute them.",
      monthlyNoData: "No monthly data.",
      monthlyFlagged: "Months outside the band",
      monthlySpike: "Year-end spike",
      monthlyNone: "No month is outside the band.",
      monthlyNoSpike: "No year-end spike.",
      monthlyBand: "Band rule: a month is flagged when it is outside the average of the period's months ± 2 standard deviations.",
      monthlySpikeRule: "Year-end spike rule: the last month of the period is more than 1.5 × the average of the other months.",
      cutoffLinks: "Cut-off worksheets",
      jeLink: "Journal entry testing",
      prefill: "{n} lines highlighted, {m} with remarks",
      response: { Yes: "Yes", No: "No", "N/A": "N/A" },
      comment: "Comment",
      saveConclusion: "Save conclusion",
      conclusionSaved: "Conclusion saved",
      conclusionFailed: "The conclusion could not be saved.",
      na: "—",
    },
  },
  ar: {
    layoutNav: {
      items: {
        completion: "نماذج الإكمال",
        final_analytical_review: "المراجعة التحليلية النهائية",
      },
    },
    far: {
      selectEngagement: "اختر ارتباطًا لفتح مراجعته التحليلية النهائية.",
      tabForms: "النماذج",
      tabFar: "المراجعة التحليلية النهائية",
      title: "316(a) المراجعة التحليلية النهائية",
      intro: "تُحتسب الأرقام من القوائم المالية. تُحفظ الملاحظات والتقييم والتوقيعات في النموذج {ref}.",
      loading: "جارٍ تحميل المراجعة التحليلية النهائية…",
      loadFailed: "تعذّر تحميل المراجعة التحليلية النهائية.",
      refresh: "تحديث",
      refreshed: "تم تحديث الأرقام",
      computedAt: "تاريخ الاحتساب",
      exportPdf: "تصدير PDF",
      exportXlsx: "تصدير Excel",
      exportFailed: "تعذّر إنشاء الملف المُصدَّر.",
      locked: "هذا الارتباط مقفل — المراجعة للقراءة فقط.",
      changedAfterSignoff: "تغيّرت الأرقام بعد التوقيع على هذه المراجعة. راجع التغييرات ووقّع مرة أخرى.",
      layer: {
        cyAdj: "شاملة تسويات المراجعة",
        cyUnadj: "أرقام غير معدّلة من بيانات العميل",
        py: "السنة السابقة",
      },
      priorNote: "السنة السابقة من دفتر أستاذ السنة السابقة — قد تختلف عن أرقام المقارنة المدققة إذا لم تُقيَّد تسويات السنة السابقة.",
      thresholds: "قاعدة التمييز: حركة تزيد على الأهمية النسبية للأداء ({pm}) وتزيد على {pct}% من السنة السابقة (الشرطان معًا). للعلم فقط — لا يُمنع أي إجراء.",
      noThresholds: "لا تمييز: لم تُحدَّد الأهمية النسبية.",
      overrideBtn: "تغيير المبلغ المتوقع",
      overrideExpected: "المبلغ المتوقع",
      overrideReason: "السبب (إلزامي)",
      overrideSave: "حفظ",
      overrideCancel: "إلغاء",
      overrideUndo: "التراجع عن التغيير",
      overridden: "غيّره المراجع ({by}): {reason} — المبلغ المحتسب {computed}",
      overrideSaved: "تم تغيير التوقع.",
      overrideRemoved: "عاد التوقع المحتسب.",
      overrideFailed: "تعذّر تغيير التوقع.",
      overridePending: "تم التغيير (لم يُحفظ بعد): {reason} — المبلغ المحتسب {computed}",
      savedAt: "تاريخ الحفظ في النموذج",
      workDonePlaceholder: "العمل المنجز على هذا البند (اختياري)",
      nothingToSave: "لم يتغيّر شيء — لا يوجد ما يُحفظ.",
      saveFailed: "تعذّر حفظ المراجعة التحليلية النهائية.",
      figuresNotSaved: "الأرقام المعروضة لم تُحفظ في النموذج بعد — اضغط حفظ لتسجيلها.",
      figuresChangedUnsaved: "تغيّرت الأرقام منذ آخر حفظ في النموذج — اضغط حفظ لتسجيل الأرقام الجديدة.",
      sec: {
        lines: "بنود القوائم المالية",
        ratios: "النسب المالية",
        planning: "التخطيط مقابل الإنجاز",
        expectations: "توقعات مبنية على بيانات الارتباط",
        relationships: "علاقات قائمة المركز المالي",
        monthly: "الاتجاهات الشهرية",
        conclusion: "الاستنتاج",
      },
      col: {
        line: "البند",
        movement: "الحركة",
        movementPct: "نسبة الحركة %",
        ajeEffect: "أثر التسويات",
        remark: "ملاحظة / تفسير",
        links: "العمل المنجز",
        ratio: "النسبة",
        change: "التغيّر",
        planning205a: "عند التخطيط (205(a))",
        expectation: "التوقع",
        formula: "طريقة البناء",
        expected: "المتوقع",
        actual: "الفعلي",
        difference: "الفرق",
        relationship: "العلاقة",
        ratioValue: "من القوائم المالية",
        dataValue: "من البيانات",
        month: "الشهر",
        revenue: "الإيرادات",
        costOfSales: "تكلفة المبيعات",
        grossMargin: "نسبة مجمل الربح %",
        payroll: "الرواتب",
        otherCosts: "تكاليف تشغيلية أخرى",
      },
      highlight: "حركة كبيرة — للعلم",
      crossed: "تجاوزت حدًّا منذ التخطيط",
      subtotal: "مجموع فرعي",
      sfp: "قائمة المركز المالي",
      pl: "الربح أو الخسارة",
      saveRemark: "حفظ",
      remarkSaved: "تم حفظ الملاحظة",
      remarkFailed: "تعذّر حفظ الملاحظة.",
      remarkPlaceholder: "فسّر الحركة (اختياري)",
      aiDraftMarker: "مسودة بالذكاء الاصطناعي — يُرجى التأكيد",
      confirm: "تأكيد",
      confirmed: "تم تأكيد المسودة",
      draftOne: "صياغة تفسير",
      draftHighlighted: "صياغة للبنود المميزة",
      drafted: "أُضيفت المسودة — عدّلها أو أكّدها",
      noAiKey: "لا يوجد مفتاح ذكاء اصطناعي مُعدّ لمنشأتك — يمكن كتابة التفسيرات يدويًا.",
      noHighlighted: "لا توجد بنود مميزة للصياغة.",
      links: { misstatements: "التحريفات", risks: "المخاطر", kams: "أمور المراجعة الرئيسية", none: "لا يوجد" },
      planningAje: "أثر قيود التسوية المُرحَّلة، بندًا بندًا",
      planningNoAje: "لا يغيّر أي قيد تسوية مُرحَّل أي بند.",
      planningRatios: "النسب التي تجاوزت حدًّا منذ التخطيط",
      planningNoRatios: "لم تتجاوز أي نسبة حدًّا.",
      planning205a: "ما سجّله النموذج 205(a) عند التخطيط (للقراءة فقط)",
      planning205aEmpty: "لم يُعبّأ النموذج 205(a) عند التخطيط.",
      noData: "لا توجد بيانات لبناء توقع",
      addExpectation: "إضافة توقع",
      expLabel: "التوقع",
      expExpected: "المبلغ المتوقع",
      expLine: "المقارنة مع البند",
      expFormula: "طريقة البناء",
      add: "إضافة",
      remove: "حذف",
      expAdded: "تمت إضافة التوقع",
      expRemoved: "تم حذف التوقع",
      expFailed: "تعذّر حفظ التوقع.",
      custom: "أضافه المراجع",
      monthlyNeedsRun: "تُحتسب الاتجاهات الشهرية في الخلفية. اضغط تشغيل لاحتسابها.",
      monthlyNoData: "لا توجد بيانات شهرية.",
      monthlyFlagged: "أشهر خارج النطاق",
      monthlySpike: "ارتفاع في نهاية السنة",
      monthlyNone: "لا يوجد شهر خارج النطاق.",
      monthlyNoSpike: "لا يوجد ارتفاع في نهاية السنة.",
      monthlyBand: "قاعدة النطاق: يُميَّز الشهر إذا خرج عن متوسط أشهر الفترة ± انحرافين معياريين.",
      monthlySpikeRule: "قاعدة ارتفاع نهاية السنة: آخر شهر في الفترة يزيد على 1.5 × متوسط الأشهر الأخرى.",
      cutoffLinks: "أوراق عمل الفصل الزمني",
      jeLink: "اختبار قيود اليومية",
      prefill: "{n} بنود مميزة، {m} منها بملاحظات",
      response: { Yes: "نعم", No: "لا", "N/A": "لا ينطبق" },
      comment: "تعليق",
      saveConclusion: "حفظ الاستنتاج",
      conclusionSaved: "تم حفظ الاستنتاج",
      conclusionFailed: "تعذّر حفظ الاستنتاج.",
      na: "—",
    },
  },
};

export default I18N_FAR;
